import { GenericsUtils } from "@/utils/generics.util";

export var Speeds = [
  {
    name: GenericsUtils.translateI18n("voice.low"),
    value: 1.1,
    valueWindows: 1.0,
  },
  {
    name: GenericsUtils.translateI18n("voice.normal"),
    value: 1.2,
    valueWindows: 1.5,
  },
  {
    name: GenericsUtils.translateI18n("voice.medium"),
    value: 1.3,
    valueWindows: 2.0,
  },
  {
    name: GenericsUtils.translateI18n("voice.fast"),
    value: 1.5,
    valueWindows: 2.5,
  },
];
